
import {
  dropdownButton
} from './helpers'

$(document).ready(function() {
  dropdownButton().init()
})